module.exports = __webpack_public_path__ + "img/logo.9071b223.png";